<template>
    <div>
        <!-- 检索条件 -->
        <div>
            <el-form :inline="true" @submit.native.prevent>
                <el-row>
                    <el-form-item label="盘点单号:">
                        <el-input style="width:200px" clearable placeholder="请输入盘点单号" v-model.trim="getData.ipmId" size="mini">
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData" id="btn">查询</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </div>
        <el-table :fit="true" ref="moviesTable" height="420" size="mini" stripe border :data="returnData.list" highlight-current-row @row-click="rowClick" @row-dblclick="rowdblClick">
            <template v-for="(tableValye,tableKey) in fromNamelist">
                <el-table-column v-if="tableValye.isShow==1" show-overflow-tooltip :min-width="tableValye.fieldWeight" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField">
                    <template slot-scope="scope">
                        <span v-if="tableValye.fieldType == 'date'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                            </span>
                        </span>
                        <span v-else-if="tableValye.entityField == 'createTime'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                            </span>
                        </span>
                        <span v-else-if="tableValye.entityField == 'ipmState'">
                            <el-tag size="mini">{{$common.getIsGsp(tableValye.formatterContent,scope.row.ipmState)}}</el-tag>
                        </span>
                        <span v-else>
                            {{scope.row[tableValye.entityField]}}
                        </span>
                    </template>
                </el-table-column>
            </template>
        </el-table>
    </div>
</template>

<script>
export default {
    props: {
        obj: {
            type: Object,
            default: () => {
                return {

                }
            }
        },
        fromNamelist: {
            type: Array,
            default: () => {
                return []
            }
        },
    },
    data() {
        return {
            returnData: {
                list: [],
                name: [],
                obj: {
                    total: 0
                }
            },
            getData: {
                page: 1,
                rows: 10,
                ipmId: "",
            },
            selectedDataIndex: 0
        }
    },
    created() {
        for (const key in this.obj) {
            this.getData[key] = this.obj[key]
        }
        this.queryData()
    },
    methods: {
        keyUpChildEnter(e) {
            // 表格为空，不执行下方 
            if (!this.returnData.list || !this.returnData.list) return
            if (e.keyCode == 13) {
                this.$emit("TranData", this.returnData.list[this.selectedDataIndex]);
            }
        },
        rowClick(row) {
            this.returnData.list.forEach((item, index) => {
                if (item.name == row.name) {
                    this.selectedDataIndex = index
                }
            })
        },
        rowdblClick(row) {
            this.$emit("TranData", row)
        },
        searchData() {
            this.queryData()
        },
        async queryData() {
            const responseData = await this.$http.queryCheckInvPlanRoomLoss(this.getData)
            console.log(responseData);
            this.returnData.list = responseData.result.list
            this.returnData.obj.total = responseData.result.total
            this.$nextTick(() => {
                if (this.returnData.list != 0) {
                    this.$refs.moviesTable.setCurrentRow(this.returnData.list[0]);
                }
                if (this.returnData.list.length == 1 && this.returnData.obj.total == 1) {
                    this.$emit("TranData", this.returnData.list[0]);
                    return
                }
            })
        },
        
        keyUpChild(e) {
            // 表格为空，不执行下方 
            if (!this.returnData.list) return

            if (e.keyCode == 40) { // 下键
                let refsElTable = this.$refs.moviesTable
                if (!refsElTable) return;
                this.$nextTick(() => {
                    if (this.selectedDataIndex == this.returnData.list.length - 1) {
                        // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDataIndex = 0
                        this.$refs.moviesTable.setCurrentRow(this.returnData.list[0]);
                    } else {
                        // 正常递增
                        this.selectedDataIndex++;
                        this.$refs.moviesTable.setCurrentRow(this.returnData.list[this.selectedDataIndex]);
                    }
                });
            } else if (e.keyCode == 38) {
                // 上键
                let refsElTable = this.$refs.moviesTable;
                if (!refsElTable) return;
                this.$nextTick(() => {
                    if (this.selectedDataIndex == 0) {
                        // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDataIndex = this.returnData.list.length - 1;
                        this.$refs.moviesTable.setCurrentRow(this.returnData.list[this.selectedDataIndex]);
                    } else {
                        // 正常递减
                        this.selectedDataIndex--;
                        this.$refs.moviesTable.setCurrentRow(this.returnData.list[this.selectedDataIndex]);
                    }
                });
            }
        },
    },
    mounted() {
        addEventListener('keyup', this.keyUpChild)
        addEventListener('keyup', this.keyUpChildEnter)
    },
    beforeDestroy() {
        removeEventListener('keyup', this.keyUpChild)
        removeEventListener('keyup', this.keyUpChildEnter)
    },
}
</script>

<style>
</style>